/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createTenant = /* GraphQL */ `mutation CreateTenant(
  $input: CreateTenantInput!
  $condition: ModelTenantConditionInput
) {
  createTenant(input: $input, condition: $condition) {
    id
    tenantname
    subtenant
    address
    contact
    phone
    status
    servicepackage
    statuspayment
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTenantMutationVariables,
  APITypes.CreateTenantMutation
>;
export const updateTenant = /* GraphQL */ `mutation UpdateTenant(
  $input: UpdateTenantInput!
  $condition: ModelTenantConditionInput
) {
  updateTenant(input: $input, condition: $condition) {
    id
    tenantname
    subtenant
    address
    contact
    phone
    status
    servicepackage
    statuspayment
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTenantMutationVariables,
  APITypes.UpdateTenantMutation
>;
export const deleteTenant = /* GraphQL */ `mutation DeleteTenant(
  $input: DeleteTenantInput!
  $condition: ModelTenantConditionInput
) {
  deleteTenant(input: $input, condition: $condition) {
    id
    tenantname
    subtenant
    address
    contact
    phone
    status
    servicepackage
    statuspayment
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTenantMutationVariables,
  APITypes.DeleteTenantMutation
>;
export const createVehicleAlarm = /* GraphQL */ `mutation CreateVehicleAlarm(
  $input: CreateVehicleAlarmInput!
  $condition: ModelVehicleAlarmConditionInput
) {
  createVehicleAlarm(input: $input, condition: $condition) {
    id
    vehiclecode
    alarm
    timestamps
    vehicleID
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateVehicleAlarmMutationVariables,
  APITypes.CreateVehicleAlarmMutation
>;
export const updateVehicleAlarm = /* GraphQL */ `mutation UpdateVehicleAlarm(
  $input: UpdateVehicleAlarmInput!
  $condition: ModelVehicleAlarmConditionInput
) {
  updateVehicleAlarm(input: $input, condition: $condition) {
    id
    vehiclecode
    alarm
    timestamps
    vehicleID
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateVehicleAlarmMutationVariables,
  APITypes.UpdateVehicleAlarmMutation
>;
export const deleteVehicleAlarm = /* GraphQL */ `mutation DeleteVehicleAlarm(
  $input: DeleteVehicleAlarmInput!
  $condition: ModelVehicleAlarmConditionInput
) {
  deleteVehicleAlarm(input: $input, condition: $condition) {
    id
    vehiclecode
    alarm
    timestamps
    vehicleID
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteVehicleAlarmMutationVariables,
  APITypes.DeleteVehicleAlarmMutation
>;
export const createVehicle = /* GraphQL */ `mutation CreateVehicle(
  $input: CreateVehicleInput!
  $condition: ModelVehicleConditionInput
) {
  createVehicle(input: $input, condition: $condition) {
    id
    vehiclecode
    typevehicle
    location
    status
    VehicleAlarms {
      nextToken
      __typename
    }
    category
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateVehicleMutationVariables,
  APITypes.CreateVehicleMutation
>;
export const updateVehicle = /* GraphQL */ `mutation UpdateVehicle(
  $input: UpdateVehicleInput!
  $condition: ModelVehicleConditionInput
) {
  updateVehicle(input: $input, condition: $condition) {
    id
    vehiclecode
    typevehicle
    location
    status
    VehicleAlarms {
      nextToken
      __typename
    }
    category
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateVehicleMutationVariables,
  APITypes.UpdateVehicleMutation
>;
export const deleteVehicle = /* GraphQL */ `mutation DeleteVehicle(
  $input: DeleteVehicleInput!
  $condition: ModelVehicleConditionInput
) {
  deleteVehicle(input: $input, condition: $condition) {
    id
    vehiclecode
    typevehicle
    location
    status
    VehicleAlarms {
      nextToken
      __typename
    }
    category
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteVehicleMutationVariables,
  APITypes.DeleteVehicleMutation
>;
export const createTyreAlarm = /* GraphQL */ `mutation CreateTyreAlarm(
  $input: CreateTyreAlarmInput!
  $condition: ModelTyreAlarmConditionInput
) {
  createTyreAlarm(input: $input, condition: $condition) {
    id
    serialnumber
    sensorid
    brand
    typetyre
    vehiclecode
    position
    alarms
    timestamps
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTyreAlarmMutationVariables,
  APITypes.CreateTyreAlarmMutation
>;
export const updateTyreAlarm = /* GraphQL */ `mutation UpdateTyreAlarm(
  $input: UpdateTyreAlarmInput!
  $condition: ModelTyreAlarmConditionInput
) {
  updateTyreAlarm(input: $input, condition: $condition) {
    id
    serialnumber
    sensorid
    brand
    typetyre
    vehiclecode
    position
    alarms
    timestamps
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTyreAlarmMutationVariables,
  APITypes.UpdateTyreAlarmMutation
>;
export const deleteTyreAlarm = /* GraphQL */ `mutation DeleteTyreAlarm(
  $input: DeleteTyreAlarmInput!
  $condition: ModelTyreAlarmConditionInput
) {
  deleteTyreAlarm(input: $input, condition: $condition) {
    id
    serialnumber
    sensorid
    brand
    typetyre
    vehiclecode
    position
    alarms
    timestamps
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTyreAlarmMutationVariables,
  APITypes.DeleteTyreAlarmMutation
>;
export const createTyre = /* GraphQL */ `mutation CreateTyre(
  $input: CreateTyreInput!
  $condition: ModelTyreConditionInput
) {
  createTyre(input: $input, condition: $condition) {
    id
    serialnumber
    brand
    typetyre
    vehiclecode
    position
    sensorid
    pressure
    temperature
    battery
    status
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTyreMutationVariables,
  APITypes.CreateTyreMutation
>;
export const updateTyre = /* GraphQL */ `mutation UpdateTyre(
  $input: UpdateTyreInput!
  $condition: ModelTyreConditionInput
) {
  updateTyre(input: $input, condition: $condition) {
    id
    serialnumber
    brand
    typetyre
    vehiclecode
    position
    sensorid
    pressure
    temperature
    battery
    status
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTyreMutationVariables,
  APITypes.UpdateTyreMutation
>;
export const deleteTyre = /* GraphQL */ `mutation DeleteTyre(
  $input: DeleteTyreInput!
  $condition: ModelTyreConditionInput
) {
  deleteTyre(input: $input, condition: $condition) {
    id
    serialnumber
    brand
    typetyre
    vehiclecode
    position
    sensorid
    pressure
    temperature
    battery
    status
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTyreMutationVariables,
  APITypes.DeleteTyreMutation
>;
export const createAdmin = /* GraphQL */ `mutation CreateAdmin(
  $input: CreateAdminInput!
  $condition: ModelAdminConditionInput
) {
  createAdmin(input: $input, condition: $condition) {
    id
    nik
    name
    email
    position
    tenant
    username
    password
    accessrole
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAdminMutationVariables,
  APITypes.CreateAdminMutation
>;
export const updateAdmin = /* GraphQL */ `mutation UpdateAdmin(
  $input: UpdateAdminInput!
  $condition: ModelAdminConditionInput
) {
  updateAdmin(input: $input, condition: $condition) {
    id
    nik
    name
    email
    position
    tenant
    username
    password
    accessrole
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAdminMutationVariables,
  APITypes.UpdateAdminMutation
>;
export const deleteAdmin = /* GraphQL */ `mutation DeleteAdmin(
  $input: DeleteAdminInput!
  $condition: ModelAdminConditionInput
) {
  deleteAdmin(input: $input, condition: $condition) {
    id
    nik
    name
    email
    position
    tenant
    username
    password
    accessrole
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAdminMutationVariables,
  APITypes.DeleteAdminMutation
>;
export const createSensorValue = /* GraphQL */ `mutation CreateSensorValue(
  $input: CreateSensorValueInput!
  $condition: ModelSensorValueConditionInput
) {
  createSensorValue(input: $input, condition: $condition) {
    id
    sensorId
    pH
    temperature
    salinity
    disolvedO2
    status
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSensorValueMutationVariables,
  APITypes.CreateSensorValueMutation
>;
export const updateSensorValue = /* GraphQL */ `mutation UpdateSensorValue(
  $input: UpdateSensorValueInput!
  $condition: ModelSensorValueConditionInput
) {
  updateSensorValue(input: $input, condition: $condition) {
    id
    sensorId
    pH
    temperature
    salinity
    disolvedO2
    status
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSensorValueMutationVariables,
  APITypes.UpdateSensorValueMutation
>;
export const deleteSensorValue = /* GraphQL */ `mutation DeleteSensorValue(
  $input: DeleteSensorValueInput!
  $condition: ModelSensorValueConditionInput
) {
  deleteSensorValue(input: $input, condition: $condition) {
    id
    sensorId
    pH
    temperature
    salinity
    disolvedO2
    status
    timestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSensorValueMutationVariables,
  APITypes.DeleteSensorValueMutation
>;
